"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _useDeploymentIdFromUrl = _interopRequireDefault(require("../../hooks/useDeploymentIdFromUrl.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(component) {
  var Component = component;
  return function (props) {
    var loading = (0, _useDeploymentIdFromUrl["default"])();
    if (loading) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: true
      });
    }
    return /*#__PURE__*/_react["default"].createElement(Component, props);
  };
};